<template>
    <div class="request-new-permission-container">
        <vs-button
            color="warning"
            type="filled"
            class="px-2 py-1"
            v-if="isVisible"
            @click="openRequestNewPermissionDialog(result)"
        >{{ label }}</vs-button>

        <!-- New permission request dialog -->
        <vs-prompt
            :active.sync="activePrompt"
            title="Solicitar alteração de permissão"
            accept-text="Solicitar"
            cancel-text="Cancelar"
            @accept="requestNewPermission"
        >
            <div @click="closeSelects">
                <vs-select class="mr-4" label="Nível de Acesso" v-model="selectedAccessLevel">
                    <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                        v-for="(item, index) in accessLevels"
                    />
                </vs-select>

                <vs-select
                    class="mr-4"
                    placeholder="Selecione os usuários"
                    multiple
                    label="Usuários"
                    v-model="selectedUsers"
                    :disabled="!showSelectUsers"
                    ref="usersSelect"
                >
                    <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                        v-for="(item, index) in usersOptions"
                    />
                </vs-select>
            </div>
        </vs-prompt>
    </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
export default {
    name: "DdRequestNewPermission",
    data() {
        return {
            accessLevels: [
                { text: "Administrador", value: "administrator" },
                { text: "Todos os irmãos", value: "restrict" },
                {
                    text: "Irmãos (apenas selecionados)",
                    value: "specific_restrict"
                },
                { text: "Público", value: "public" }
            ],
            activePrompt: false
        };
    },
    props: {
        documentId: null,
        documentTitle: null,
        label: {
            default: "Solicitar mudança de permissão",
            type: String
        },
        isVisible: {
            default: true,
            type: Boolean
        }
    },
    computed: {
        ...sync([
            "search/selectedAccessLevel",
            "search/selectedUsers",
            "users/users"
        ]),
        showSelectUsers() {
            return this.selectedAccessLevel === "specific_restrict";
        },
        usersOptions() {
            const options = this.users.map(user => ({
                text: user.name,
                value: user.id
            }));

            return options;
        }
    },
    methods: {
        ...call({
            submitDocumentRequest: "search/submitDocumentRequest"
        }),
        closeSelects() {
            this.$refs.usersSelect.closeOptions();
        },
        openRequestNewPermissionDialog() {
            this.activePrompt = true;
        },
        async requestNewPermission() {
            this.$vs.loading();

            try {
                const response = await this.submitDocumentRequest({
                    documentName: this.documentTitle,
                    documentId: this.documentId
                });

                this.$vs.loading.close();
                this.$vs.notify({
                    title: response,
                    color: "success",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            } catch (error) {
                this.$vs.loading.close();
                this.$vs.notify({
                    title: "Erro",
                    text:
                        "Ocorreu um erro ao enviar sua solicitação. Tente novamente, por favor.",
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle"
                });
            }
        }
    }
};
</script>